// extracted by mini-css-extract-plugin
export default {"text_link":"styles_text_link__1da82"};